import gql from 'graphql-tag'
import {
  PRODUCT_AVAILABILITY_FRAGMENT,
  PRODUCT_ESTIMATED_DELIVERY_FRAGMENT,
} from '~/graphql/gql/product/fragments'
import { PRODUCT_BY_VARIANT_IDS } from '~/graphql/gql/product/fragments/productVariantsIdsFragment'

export const GET_BESTSELLERS_CAROUSEL = gql`
  query {
    getBestsellersCarousel {
      ...ProductVariantsIdsFragment
    }
  }

  ${PRODUCT_BY_VARIANT_IDS}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`
